export default class GTMEvents {
    constructor(element = null) {
        this.element = element;
    }

    init() {
        this.download();
        this.submit();
    }

    download() {
        this.element?.querySelectorAll('[data-download-pdf]').forEach((element) => {
            element.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'download_pdf',
                    'hostname':  'frgmnt.cz',
                    'lead_type': 'rent'
				});
            });
        });
    }

    submit() {
        document.addEventListener( 'wpcf7mailsent', function( event ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'generate_lead',
                'hostname':  'frgmnt.cz',
                'lead_type': 'rent'
            });
        }); 
    }
}